import qs from "qs";
import axios from "axios";
import { URL, API_URL } from "../../../../constants/Constants";

/**
 * Obtiene lista de metales
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @returns {Promise<Array|false>} Lista de metales o false si hay error
 */
export const getListMetals = async (type, typeConnect) => {
  const queryData = {
    screen: "foundry",
    action: "query",
  };

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};

/**
 * Obtiene lista de MO con aleación (o lista de metales si no se proporciona aleación)
 * @param {string} type - Tipo de consulta (mantenido por compatibilidad, no se usa)
 * @param {string} typeConnect - Tipo de conexión (mantenido por compatibilidad, no se usa)
 * @param {string} aleacion - Aleación (opcional - si no se envía, devuelve lista de metales)
 * @returns {Promise<Array|false>} Lista de MO con aleación o lista de metales o false si hay error
 */
export const getListMoWithAleacion = async (type, typeConnect, aleacion = null) => {
  const queryData = {
    screen: "foundry",
    action: "query",
  };

  // Agregar aleación solo si se proporciona
  if (aleacion) {
    queryData.aleacion = aleacion;
  }

  try {
    const response = await axios.post(API_URL, qs.stringify(queryData));
    if (response.data.status === "ok") {
      return response.data.data;
    } else {
      console.log("Pieza no encontrada");
      return false;
    }
  } catch (error) {
    console.error("Error al enviar la conexión POST:", error);
    return false;
  }
};
